const routes = [
	{
		path: '/notificaciones',
		component: () => import('@/views/dashboard/notifications/List.vue'),
		meta: {
			auth: true
		}
	}
];


export default routes;